module.exports = __webpack_public_path__ + "img/sub-nav-links-mitsu.75219dd8.png";